import { createSelector } from 'reselect';

import { RequestState } from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

export type AccountScoreGenerationLogState = {
  recentAccountScoreGenerationLog: AccountScoreGenerationLog | null;
  recentAccountScoreGenerationLogStatus: RequestState;
};
type State = { accountScoreGenerationLogs: AccountScoreGenerationLogState };

const accountScoreGenerationLogStatusSelector = (state: State) =>
  state.accountScoreGenerationLogs.recentAccountScoreGenerationLogStatus;
export const recentAccountScoreGenerationLogStatusSelector = createSelector(
  [accountScoreGenerationLogStatusSelector],
  (recentAccountScoreGenerationLogStatus) => recentAccountScoreGenerationLogStatus,
);

const recentAccountScoresSelector = (state: State) =>
  state.accountScoreGenerationLogs.recentAccountScoreGenerationLog?.accountScores || [];
const accountScoreByAccountIdSelector = createSelector(
  [recentAccountScoresSelector],
  (accountScores) => convertArrayToMap(accountScores, (as) => as.accountId.toString()),
);
export const accountScoreForAccountIdSelector = createSelector(
  [accountScoreByAccountIdSelector, (_state: State, accountId: number) => accountId],
  (accountScores, accountId) => accountScores[accountId],
);
